import { render, staticRenderFns } from "./setpwd.vue?vue&type=template&id=6834bb9a&scoped=true"
import script from "./setpwd.vue?vue&type=script&lang=js"
export * from "./setpwd.vue?vue&type=script&lang=js"
import style0 from "./setpwd.vue?vue&type=style&index=0&id=6834bb9a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6834bb9a",
  null
  
)

export default component.exports